import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/404/404-cat.png';
const _withScopeId = n => (_pushScopeId("data-v-455f9cd3"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "not-found-container"
};
const _hoisted_2 = {
  style: {
    "margin-bottom": "120px"
  }
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "404猫咪",
  class: "error-image"
}, null, -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "error-message"
}, "啊哦～这个页面好像走丢了呢 (●'◡'●)", -1));
const _hoisted_5 = {
  class: "actions"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-home"
}, null, -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-arrow-left"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(_component_router_link, {
    to: "/",
    class: "home-button"
  }, {
    default: _withCtx(() => [_hoisted_6, _createTextVNode(" 返回首页 ")]),
    _: 1
  }), _createElementVNode("button", {
    class: "back-button",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.goBack && $options.goBack(...args))
  }, [_hoisted_7, _createTextVNode(" 返回上一页 ")])])])]);
}